export type ApiRequestStatus = 'idle' | 'pending' | 'error' | 'success'

import { EXPERIMENTS_STORAGE_KEY } from 'utils/experiments/experiments'

export function combinedStatus(statuses: ApiRequestStatus[]): ApiRequestStatus {
  if (statuses.includes('error')) {
    return 'error'
  }

  if (statuses.includes('pending')) {
    return 'pending'
  }

  if (statuses.every((status) => status === 'success')) {
    return 'success'
  }
  return 'idle'
}

export function clearLocalStorage() {
  // Clear the local storage, but keep the language and experiments.
  const language = localStorage.getItem('language')
  const experiments = localStorage.getItem(EXPERIMENTS_STORAGE_KEY)
  localStorage.clear()
  if (language) {
    localStorage.setItem('language', language)
  }
  if (experiments) {
    localStorage.setItem(EXPERIMENTS_STORAGE_KEY, experiments)
  }
}

/**
 * Picks defined (non-null and non-undefined) values from an object.
 * @param obj - The object to pick defined values from
 * @returns A new object with only the defined values
 */
export function pickDefined<T extends Record<string, unknown>>(
  obj: T
): Partial<{ [K in keyof T]: Exclude<T[K], null | undefined> }> {
  const result: Record<string, unknown> = {}
  for (const [k, v] of Object.entries(obj)) {
    if (v !== undefined && v !== null) result[k] = v
  }
  return result as Partial<{ [K in keyof T]: Exclude<T[K], null | undefined> }>
}
